import { AuthService } from '@app/auth.service';
var UserService = /** @class */ (function () {
    function UserService(Auth) {
        this.Auth = Auth;
    }
    UserService.prototype.isLoggedIn = function () {
        var result = {
            status: false
        };
        var cookieData = JSON.parse(localStorage.getItem('dpa_cc'));
        if (cookieData != null && cookieData.userId != null && cookieData.userId != "") {
            result.status = true;
        }
        return result;
    };
    UserService.prototype.logout = function () {
        localStorage.setItem('dpa_cc', null);
        this.Auth.setLoggedIn(false);
        var result = {
            status: false
        };
        return result;
    };
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// ./src/app/user.service.ts.pre-build-optimizer.js